import { ColDef } from "ag-grid-community";
import { DateTimeCell } from "./DateTimecell";

export const shipmentLogsColumnsData = [
  {
    headerName: "Date/Time",
    field: "actionTimestamp",
    width: 250,
    autoHeight: true,
    wrapText: true,
    sortable: false,
    cellStyle: (params) => {
      return { alignItems: "flex-start", padding: "8px" };
    },
    cellRenderer: DateTimeCell,
  },
  {
    headerName: "User",
    field: "userId",
    width: 200,
  },
  { headerName: "ActionMessage", field: "action", width: 550, autoHeight: true, wrapText: true, sortable: false },
] as ColDef[];
